import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import P from "../../_internal/icon/src/Icon.js";
import b from "../../_internal/icons/Success.js";
import v from "../../_internal/icons/Error.js";
import C from "../../_internal/icons/Warning.js";
import k from "../../_internal/icons/Info.js";
import { defineComponent as w, h as e } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const I = {
  success: e(b, null),
  error: e(v, null),
  warning: e(C, null),
  info: e(k, null)
}, _ = w({
  name: "ProgressCircle",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    status: {
      type: String,
      required: !0
    },
    strokeWidth: {
      type: Number,
      required: !0
    },
    fillColor: [String, Object],
    railColor: String,
    railStyle: [String, Object],
    percentage: {
      type: Number,
      default: 0
    },
    offsetDegree: {
      type: Number,
      default: 0
    },
    showIndicator: {
      type: Boolean,
      required: !0
    },
    indicatorTextColor: String,
    unit: String,
    viewBoxWidth: {
      type: Number,
      required: !0
    },
    gapDegree: {
      type: Number,
      required: !0
    },
    gapOffsetDegree: {
      type: Number,
      default: 0
    }
  },
  setup(s, {
    slots: y
  }) {
    function S(n, i, o, f) {
      const {
        gapDegree: l,
        viewBoxWidth: a,
        strokeWidth: g
      } = s, r = 50, h = 0, c = r, t = 0, d = 2 * r, p = 50 + g / 2, $ = `M ${p},${p} m ${h},${c}
      a ${r},${r} 0 1 1 ${t},${-d}
      a ${r},${r} 0 1 1 ${-t},${d}`, m = Math.PI * 2 * r, u = {
        stroke: f === "rail" ? o : typeof s.fillColor == "object" ? "url(#gradient)" : o,
        strokeDasharray: `${n / 100 * (m - l)}px ${a * 8}px`,
        strokeDashoffset: `-${l / 2}px`,
        transformOrigin: i ? "center" : void 0,
        transform: i ? `rotate(${i}deg)` : void 0
      };
      return {
        pathString: $,
        pathStyle: u
      };
    }
    const x = () => {
      const n = typeof s.fillColor == "object", i = n ? s.fillColor.stops[0] : "", o = n ? s.fillColor.stops[1] : "";
      return n && e("defs", null, e("linearGradient", {
        id: "gradient",
        x1: "0%",
        y1: "100%",
        x2: "100%",
        y2: "0%"
      }, e("stop", {
        offset: "0%",
        "stop-color": i
      }), e("stop", {
        offset: "100%",
        "stop-color": o
      })));
    };
    return () => {
      const {
        fillColor: n,
        railColor: i,
        strokeWidth: o,
        offsetDegree: f,
        status: l,
        percentage: a,
        showIndicator: g,
        indicatorTextColor: r,
        unit: h,
        gapOffsetDegree: c,
        clsPrefix: t
      } = s, {
        pathString: d,
        pathStyle: p
      } = S(100, 0, i, "rail"), {
        pathString: $,
        pathStyle: m
      } = S(a, f, n, "fill"), u = 100 + o;
      return e("div", {
        class: `${t}-progress-content`,
        role: "none"
      }, e("div", {
        class: `${t}-progress-graph`,
        "aria-hidden": !0
      }, e("div", {
        class: `${t}-progress-graph-circle`,
        style: {
          transform: c ? `rotate(${c}deg)` : void 0
        }
      }, e("svg", {
        viewBox: `0 0 ${u} ${u}`
      }, x(), e("g", null, e("path", {
        class: `${t}-progress-graph-circle-rail`,
        d,
        "stroke-width": o,
        "stroke-linecap": "round",
        fill: "none",
        style: p
      })), e("g", null, e("path", {
        class: [`${t}-progress-graph-circle-fill`, a === 0 && `${t}-progress-graph-circle-fill--empty`],
        d: $,
        "stroke-width": o,
        "stroke-linecap": "round",
        fill: "none",
        style: m
      }))))), g ? e("div", null, y.default ? e("div", {
        class: `${t}-progress-custom-content`,
        role: "none"
      }, y.default()) : l !== "default" ? e("div", {
        class: `${t}-progress-icon`,
        "aria-hidden": !0
      }, e(P, {
        clsPrefix: t
      }, {
        default: () => I[l]
      })) : e("div", {
        class: `${t}-progress-text`,
        style: {
          color: r
        },
        role: "none"
      }, e("span", {
        class: `${t}-progress-text__percentage`
      }, a), e("span", {
        class: `${t}-progress-text__unit`
      }, h))) : null);
    };
  }
});
export {
  _ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/progress/src/Circle.js
// module id = 1729
// module chunks = 67